import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { SingleWaveDropContentMetadata } from "./SingleWaveDropContentMetadata";
interface MemesSingleWaveDropContentProps {
  readonly drop: ExtendedDrop;
}
export const MemesSingleWaveDropContent: React.FC<MemesSingleWaveDropContentProps> = t0 => {
  const $ = _c(21);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop.metadata || $[1] !== drop.title) {
    t1 = drop.metadata?.find(_temp)?.data_value || drop.title || "Artwork Title";
    $[0] = drop.metadata;
    $[1] = drop.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const title = t1;
  let t2;
  if ($[3] !== drop.metadata) {
    t2 = drop.metadata?.find(_temp2)?.data_value || "";
    $[3] = drop.metadata;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const description = t2;
  let t3;
  if ($[5] !== drop.parts) {
    t3 = drop.parts.at(0)?.media?.at(0)?.url;
    $[5] = drop.parts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const artworkMedia = t3;
  let t4;
  if ($[7] !== title) {
    t4 = <h3 className="tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-3">{title}</h3>;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = description && <p className="tw-text-iron-300 tw-mb-4 tw-text-md">{description}</p>;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== artworkMedia || $[12] !== title) {
    t6 = <div className="tw-relative tw-bg-iron-900/40 tw-w-full"><div className="tw-aspect-video tw-w-full tw-flex tw-items-center tw-justify-center">{artworkMedia ? <img src={artworkMedia} alt={title} className="tw-max-w-full tw-max-h-full tw-object-contain" /> : <div className="tw-text-center tw-text-iron-400 tw-px-6"><FontAwesomeIcon icon={faImage} className="tw-w-14 tw-h-14 tw-mx-auto tw-mb-3 tw-text-iron-700" /><p className="tw-text-sm">Artwork preview</p></div>}</div></div>;
    $[11] = artworkMedia;
    $[12] = title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== drop) {
    t7 = !!drop.metadata.length && <SingleWaveDropContentMetadata drop={drop} />;
    $[14] = drop;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="tw-mb-2 tw-flex tw-flex-col">{t4}{t5}{t6}{t7}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}